import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useToast } from '@hub-la/shadcn'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { AddNewResourceInput } from '../../../domain/dtos/member-area/add-new-resource-input'
import { QueryKey } from '../../../domain/enums/query-key'
import { AddResource } from '../../../usecases/member-area/add-resource'

export const useAddResource = () => {
  const { toast } = useToast()
  const { t } = useTranslation()
  const container = useContainer()
  const queryClient = useQueryClient()

  return useMutation(
    [QueryKey.addResource],
    (input: AddNewResourceInput) => new AddResource(container.get(HttpClient)).execute(input),
    {
      retry: false,
      onError: (error: Error) => toast({ description: t(error.message), variant: 'destructive' }),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [QueryKey.getResources] })
      },
    },
  )
}
